import { Link } from 'react-router-dom';

export default function SubmitHero() {
  return (
    <section className="relative pt-28 pb-16 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3165bf84f7efc4b7b6b29412fc6d2234.jpg"
          alt="Submit your business to Roseville directory"
          title="Submit Business Listing Roseville CA"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/70 via-gray-900/60 to-gray-900/80"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 text-center">
        <div className="flex items-center justify-center gap-2 mb-4">
          <div className="w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center">
            <i className="ri-store-3-line text-white text-lg"></i>
          </div>
          <span className="text-amber-400 font-semibold text-sm uppercase tracking-wider">
            Professional Business Listing
          </span>
        </div>

        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
          Grow Your Business with <span className="text-amber-400">Premium Visibility</span>
        </h1>
        <p className="text-lg text-white/80 mb-6 max-w-2xl mx-auto">
          Join hundreds of Roseville businesses reaching thousands of local customers. Choose your plan and start growing today.
        </p>

        <div className="flex items-center justify-center gap-6 text-sm text-white/70">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-line text-amber-400"></i>
            </div>
            Plans from $49/month
          </div>
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-line text-amber-400"></i>
            </div>
            14-day money-back guarantee
          </div>
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-check-line text-amber-400"></i>
            </div>
            Reach local customers
          </div>
        </div>

        <nav className="mt-6 text-sm text-white/50">
          <Link to="/" className="hover:text-white transition-colors cursor-pointer">Home</Link>
          <span className="mx-2">/</span>
          <Link to="/directory" className="hover:text-white transition-colors cursor-pointer">Directory</Link>
          <span className="mx-2">/</span>
          <span className="text-white/80">Submit Business</span>
        </nav>
      </div>
    </section>
  );
}
